/**
 * 验证手机号
 * @param {number} phoneNumber 
 * @returns {boolean}
 */
export function validatePhone(phoneNumber) {
    const regex = /^1[3456789]\d{9}$/;
    return regex.test(phoneNumber);
}

/**
 * 验证邮箱
 * @param {string} email 
 * @returns {boolean}
 */
export function isEmail(email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
}

/**
 * 则验证可包含汉字、字母、数字、下划线、减号、空格
 * @param {string} str 
 * @returns {boolean}
 */
export function isChineseLetterNumber(str) {
    const regex = /^[a-zA-Z0-9\u4e00-\u9fa5-_ ]+$/;
    return regex.test(str);
}

/**
 * 则验证只包含汉字、字母、数字、空格
 * @param {string} str 
 * @returns {boolean}
 */
export function isChineseLetterNumberSpace(str) {
    const regex = /^[a-zA-Z0-9\u4e00-\u9fa5 ]+$/;
    return regex.test(str);
}